import PageHeader from '@components/pageHeader';
import PortfolioSelection from '@components/portfolioSelection';
import { DescriptionOutlined } from '@mui/icons-material';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';
import { FC, useEffect } from 'react';
import { DocumentsDataGrid } from './DocumentsDataGrid';
import { useAppDispatch, useAppSelector } from '@src/app/hooks/store';
import { ScreenState } from '@src/app/enums';
import { getDocumentsAsync } from '@src/app/store/reducers/documents/thunks';
import { selectDocuments } from '@src/app/store/reducers/documents/selectors';
import { selectPortfolios } from '@src/app/store/reducers/portfolios/selectors';
import { useWindow } from '@src/app/hooks/useWindow';
import { useAppContext } from '@src/app/hooks/useAppContext';

const Documents: FC = (): JSX.Element => {
  const { clientAccounts } = useAppSelector(selectPortfolios);
  const { portfoliosKeysSelected, portfolioInfoState } = useAppSelector(selectPortfolios);
  const { state, data } = useAppSelector(selectDocuments);
  const { transitioningMenu } = useAppContext();
  const { resizing } = useWindow();
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const fetchDocumentsAsync = async () => {
    dispatch(getDocumentsAsync({ clientAccounts: clientAccounts, portfolioKeys: portfoliosKeysSelected }));
  };

  useEffect(() => {
    fetchDocumentsAsync();
  }, [clientAccounts, portfoliosKeysSelected]);

  return (
    <Container>
      <Box display="flex" flexDirection="column">
        <PageHeader title="Documents" icon={DescriptionOutlined}>
          <PortfolioSelection allowCombining={false} disabled={state === ScreenState.Loading || portfolioInfoState === ScreenState.Loading} />
        </PageHeader>
        <Grid container direction="column" mb={8} spacing={4}>
          <Grid item>
            <Typography color={theme.palette.grey['800']}>Documents related to your account.</Typography>
          </Grid>
          <Grid item mt={2}>
            {!resizing && !transitioningMenu && <DocumentsDataGrid data={data || []} isLoading={state === ScreenState.Loading} />}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Documents;
